import { OrderDetailModel } from "../model/order-detail.model";

export class SetOrderDocument {
	static readonly type = '[Quality] SetOrderDocument';

	constructor(public orderId: number) {}
}

export class SetOrderDetailModel {
	static readonly type = '[Quality] SetOrderDetailModel';

	constructor(public orderDetailModel: OrderDetailModel) {}
}

export class SetSchemaDocument {
	static readonly type = '[Quality] SetSchemaDocument';

	constructor(public schemaName: string) {}
}

export class SetOrderDocumentManually {
	static readonly type = '[Quality] SetOrderDocumentManually';

	constructor(public doc: any) {}
}

export class SetSelectedSection {
	static readonly type = '[Quality] SetSelectedSection';

	constructor(public section: any) {}
}

export class SetStateSelectedOrder {
	static readonly type = '[Quality] SetStateSelectedOrder';
	constructor(public stateEnum: string) {}
}

export class GetOrderRevisedFields {
	static readonly type = '[Quality] GetOrderRevisedFields';

	constructor(public orderId: number) {}
}

export class CleanQualityOrder {
	static readonly type = '[Quality] CleanQualityOrder';
}

export class UnregisterFromOrderChannel {
	static readonly type = '[Quality] UnregisterUserFromOrderChannel';
}

export class SetOrderisRecalled {
	static readonly type = '[Quality] SetOrderisRecalled';

	constructor(public isRecalled: boolean) {}
}

export class SetOrderPublicRecord {
	static readonly type = '[Quality] SetOrderPublicRecord';

	constructor(public orderId: number) {}
}

export class SetLeftMenu {
	static readonly type = '[Quality][Order] SetLeftMenu';

	constructor(public orderDetail: any) {
	}
}

export class ClearLeftMenu {
	static readonly type = '[Quality][Order] ClearLeftMenu';
}
